import { render, staticRenderFns } from "./P17PrapaDebtByAreaGroupReport.vue?vue&type=template&id=559d857c&"
import script from "./P17PrapaDebtByAreaGroupReport.vue?vue&type=script&lang=js&"
export * from "./P17PrapaDebtByAreaGroupReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports